import { isString } from './isString';

/**
 * Parses a prop that can be either a string, object etc
 * @param {Object|string} prop - The prop value to parse.
 * @return {Object} Parsed prop object
 */
export const parseProp = <T = unknown>(prop: T | string): T => {
  return isString(prop) ? JSON.parse(prop) : prop;
};

/**
 * Parses a prop that can be either a string or Array
 * @param {string|Array} prop - The prop value to parse
 * @returns {Array} Parsed prop array
 */
export const parsePropToArray = <T = unknown>(prop: string | T[]): T[] => {
  if (!prop) return [];

  return isString(prop) ? Array.from(JSON.parse(prop)) : prop;
};
